import { Skeleton } from '@/common/components/ui/skeleton';
import { TableBody, TableCell, TableRow } from '@/common/components/ui/table';

export const ComparatorListSkeleton = () => {
  return (
    <TableBody>
      {Array.from({ length: 4 }).map((_, index) => (
        <TableRow key={index}>
          <TableCell>
            <Skeleton className="h-4 w-32 bg-muted-foreground/20" />
          </TableCell>
          <TableCell>
            <Skeleton className="h-4 w-20 bg-muted-foreground/20 ml-auto" />
          </TableCell>
          <TableCell>
            <Skeleton className="h-4 w-20 bg-muted-foreground/20 ml-auto" />
          </TableCell>
          <TableCell>
            <Skeleton className="h-4 w-20 bg-muted-foreground/20 ml-auto" />
          </TableCell>
          <TableCell>
            <Skeleton className="h-4 w-20 bg-muted-foreground/20 ml-auto" />
          </TableCell>
          <TableCell>
            <Skeleton className="h-4 w-20 bg-muted-foreground/20 ml-auto" />
          </TableCell>
          <TableCell>
            <Skeleton className="h-4 w-20 bg-muted-foreground/20 ml-auto" />
          </TableCell>
          <TableCell>
            <Skeleton className="h-6 w-14 bg-muted-foreground/20 mx-auto" />
          </TableCell>
          <TableCell>
            <Skeleton className="h-6 w-14 bg-muted-foreground/20 mx-auto" />
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};
